var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRobot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 450,
    height: 402,
    viewBox: "0 0 450 402",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_35_222)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M252.731 112.287C252.731 112.287 249.858 150.995 233.75 160.131C233.75 160.131 285.469 151.199 298.187 131.829C310.904 112.459 252.731 112.287 252.731 112.287Z",
    fill: "url(#paint0_linear_35_222)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.217 226.497C169.347 235.227 161.817 232.783 156.138 241.326C155.485 242.306 152.155 247.319 152.821 253.751C153.353 258.877 156.208 262.833 158.004 264.572C168.922 275.141 198.964 262.211 216.169 248.07C219.92 244.987 229.985 236.717 227.958 230.842C227.127 228.435 224.547 227.239 222.696 226.411C214.512 222.75 206.023 225.18 201.217 226.497Z",
    fill: "url(#paint1_linear_35_222)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.819 12.2802H109.602V56.7927H102.819V12.2802Z",
    fill: "url(#paint2_linear_35_222)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.786 81.3808H129.633C133.088 81.3808 135.887 78.5811 135.887 75.1265V58.3837C135.887 54.9291 133.088 52.1294 129.633 52.1294H82.786C79.3314 52.1294 76.5317 54.9291 76.5317 58.3837V75.1265C76.5331 78.5811 79.3328 81.3808 82.786 81.3808Z",
    fill: "url(#paint3_linear_35_222)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0152682 178.674C0.0152682 205.715 21.9379 227.638 48.9795 227.638H163.441C190.372 227.638 212.406 205.604 212.406 178.674V153.238C212.406 105.323 173.203 66.1196 125.287 66.1196H87.1325C39.2179 66.1196 0.013916 105.322 0.013916 153.238L0.0152682 178.674Z",
    fill: "url(#paint4_linear_35_222)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4219 174.036C36.2009 175.41 39.3162 176.13 42.4815 176.13H169.938C173.103 176.13 176.219 175.41 178.998 174.036C185.824 170.662 189.676 163.848 188.712 156.859L188.641 156.351C185.375 132.675 163.933 114.473 137.645 113.105C126.522 112.526 114.85 112.227 102.675 112.298C93.1376 112.353 83.9189 112.633 75.0421 113.09C48.6541 114.449 27.0541 132.58 23.7753 156.345C23.7518 156.515 23.7282 156.687 23.7047 156.857C22.7424 163.848 26.5958 170.662 33.4219 174.036Z",
    fill: "url(#paint5_linear_35_222)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.802 170.913C126.528 170.913 115.768 160.153 115.768 146.879C115.768 133.605 126.528 122.845 139.802 122.845C153.076 122.845 163.836 133.605 163.836 146.879C163.836 160.153 153.076 170.913 139.802 170.913Z",
    fill: "url(#paint6_radial_35_222)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.802 164.13C130.275 164.13 122.551 156.406 122.551 146.879C122.551 137.351 130.275 129.628 139.802 129.628C149.329 129.628 157.053 137.351 157.053 146.879C157.053 156.406 149.329 164.13 139.802 164.13Z",
    fill: "#EEFDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.802 161.367C131.8 161.367 125.313 154.88 125.313 146.879C125.313 138.877 131.8 132.39 139.802 132.39C147.804 132.39 154.29 138.877 154.29 146.879C154.29 154.88 147.804 161.367 139.802 161.367Z",
    fill: "url(#paint7_linear_35_222)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.521 143.123C130.521 146.088 132.923 148.49 135.888 148.49C138.852 148.49 141.254 146.087 141.254 143.123C141.254 140.16 138.852 137.757 135.888 137.757C132.923 137.757 130.521 140.16 130.521 143.123Z",
    fill: "#EEFDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.944 160.132C140.761 160.132 139.802 159.174 139.802 157.99C139.802 156.808 140.761 155.848 141.944 155.848C143.126 155.848 144.086 156.808 144.086 157.99C144.086 159.174 143.126 160.132 141.944 160.132Z",
    fill: "#EEFDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.255 154.776C147.255 155.368 147.734 155.847 148.325 155.847C148.917 155.847 149.396 155.368 149.396 154.776C149.396 154.185 148.917 153.706 148.325 153.706C147.734 153.706 147.255 154.187 147.255 154.776Z",
    fill: "#EEFDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.8745 170.913C61.6007 170.913 50.8403 160.153 50.8403 146.879C50.8403 133.605 61.6007 122.845 74.8745 122.845C88.1481 122.845 98.9086 133.605 98.9086 146.879C98.9086 160.153 88.1481 170.913 74.8745 170.913Z",
    fill: "url(#paint8_radial_35_222)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.8745 164.13C65.3469 164.13 57.6235 156.406 57.6235 146.879C57.6235 137.351 65.3469 129.628 74.8745 129.628C84.4019 129.628 92.1254 137.351 92.1254 146.879C92.1254 156.406 84.4019 164.13 74.8745 164.13Z",
    fill: "#EEFDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.8744 161.367C66.8725 161.367 60.3857 154.88 60.3857 146.879C60.3857 138.877 66.8725 132.39 74.8744 132.39C82.8762 132.39 89.363 138.877 89.363 146.879C89.363 154.88 82.8762 161.367 74.8744 161.367Z",
    fill: "url(#paint9_linear_35_222)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.592 143.123C65.592 146.088 67.9957 148.49 70.9588 148.49C73.9219 148.49 76.327 146.087 76.327 143.123C76.327 140.16 73.9233 137.757 70.9588 137.757C67.9943 137.757 65.592 140.16 65.592 143.123Z",
    fill: "#EEFDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.0165 160.132C75.8335 160.132 74.8745 159.174 74.8745 157.99C74.8745 156.808 75.8335 155.848 77.0165 155.848C78.1994 155.848 79.1585 156.808 79.1585 157.99C79.1585 159.174 78.1994 160.132 77.0165 160.132Z",
    fill: "#EEFDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.3279 154.776C82.3279 155.368 82.807 155.847 83.3982 155.847C83.9894 155.847 84.4685 155.368 84.4685 154.776C84.4685 154.185 83.9894 153.706 83.3982 153.706C82.807 153.706 82.3279 154.187 82.3279 154.776Z",
    fill: "#EEFDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.5198 9.31288C97.5198 14.112 101.411 18.0041 106.211 18.0041C111.01 18.0041 114.901 14.1134 114.901 9.31288C114.901 4.51379 111.01 0.621643 106.211 0.621643C101.411 0.621643 97.5198 4.51242 97.5198 9.31288Z",
    fill: "url(#paint10_linear_35_222)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.169 5.92072C100.169 7.38426 101.355 8.56949 102.819 8.56949C104.282 8.56949 105.469 7.38288 105.469 5.92072C105.469 4.45718 104.282 3.27057 102.819 3.27057C101.355 3.27195 100.169 4.45718 100.169 5.92072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3796 93.9851C31.2647 98.042 34.5767 102.895 38.3705 103.309C41.9262 103.698 44.7661 100.065 47.6945 96.3182C50.5815 92.6254 56.8939 83.138 54.3795 80.4546C51.0661 76.9169 31.6524 84.4132 31.3796 93.9851Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.8653 78.5189C62.1974 78.5189 60.8455 77.1669 60.8455 75.4991C60.8455 73.8312 62.1974 72.4792 63.8653 72.4792C65.5331 72.4792 66.8852 73.8312 66.8852 75.4991C66.8852 77.1669 65.5331 78.5189 63.8653 78.5189Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8102 150.267C32.7794 150.951 39.535 137.188 57.6707 125.255C64.0454 121.06 70.3385 118.07 69.9647 117.201C69.5853 116.319 62.4974 117.96 56.8233 120.592C38.743 128.98 30.6582 149.454 31.8102 150.267Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.2501 60.7889C78.4661 60.8194 78.6045 59.5497 79.6624 57.5877C79.6624 57.5877 80.1567 56.6695 80.7216 55.8914C82.5424 53.3852 88.715 53.4406 89.1996 53.4448C98.813 53.5278 104.994 52.9187 104.991 52.9769C104.99 53.0254 100.481 52.934 97.1778 52.8675C87.8579 52.6778 82.3056 52.1764 79.9255 54.6729C78.9382 55.7086 78.4412 57.0572 78.4412 57.0572C77.7682 58.8877 77.9925 60.7515 78.2501 60.7889Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.2494 186.444C80.4848 188.747 82.4011 190.52 84.7051 190.742L116.543 193.812C118.846 194.033 121.066 192.661 121.738 190.446C122.037 189.461 122.267 188.446 122.423 187.402C122.466 187.114 122.39 186.821 122.21 186.589C122.03 186.36 121.764 186.214 121.474 186.185L81.3073 182.311C81.0206 182.283 80.7368 182.375 80.5194 182.563C80.302 182.751 80.1733 183.021 80.1608 183.308C80.1123 184.37 80.1442 185.417 80.2494 186.444Z",
    fill: "#EEFDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.248 186.447C81.2657 196.316 89.1124 204.43 99.3627 205.409C109.473 206.388 118.605 200.118 121.607 190.835C120.805 192.819 118.72 194.028 116.544 193.81L84.6982 190.745C82.397 190.516 80.489 188.748 80.248 186.447Z",
    fill: "url(#paint11_linear_35_222)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0864 257.952C30.0864 258.245 30.0864 258.524 30.0989 258.791C30.2 261.462 30.8244 263.471 31.129 264.374C39.8923 291.146 45.1441 305.263 52.5075 316.684C53.7786 318.655 55.1147 320.549 56.552 322.406C58.4337 324.886 60.494 327.302 62.7841 329.796C67.8712 335.329 75.5655 337.834 78.0454 338.699C87.1132 341.904 95.126 341.319 100.454 341.37H101.383C106.725 341.319 114.724 341.904 123.792 338.699C126.271 337.834 133.978 335.329 139.053 329.796C153.043 314.572 158.422 301.918 170.708 264.374C171 263.51 171.586 261.64 171.726 259.135C171.763 258.409 171.777 257.685 171.738 256.96C171.471 252.471 169.653 248.069 166.421 244.051C160.888 237.158 152.342 233.381 143.503 233.342L100.911 233.164L59.0941 232.999C50.0637 232.96 41.3143 236.751 35.5792 243.732C32.8058 247.115 31.039 250.765 30.3897 254.53C30.301 255.064 30.2249 255.611 30.1737 256.145C30.1252 256.744 30.0864 257.342 30.0864 257.952Z",
    fill: "url(#paint12_linear_35_222)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.919 233.171L143.511 233.349C152.351 233.388 160.897 237.165 166.429 244.058C169.66 248.077 171.478 252.478 171.746 256.967C171.53 252.363 169.635 247.847 166.265 243.739C160.542 236.757 151.779 232.967 142.75 233.006L100.919 233.171Z",
    fill: "url(#paint13_linear_35_222)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5871 295.92C59.2088 262.882 63.6797 256.348 57.0862 248.489C56.3288 247.586 52.4616 242.976 46.102 241.799C41.0343 240.862 36.4346 242.485 34.258 243.717C21.0377 251.207 24.9603 283.677 33.6696 304.175C35.5679 308.645 40.6619 320.634 46.8705 320.347C49.414 320.23 51.2902 318.092 52.6056 316.551C58.4279 309.731 58.493 300.9 58.5871 295.92Z",
    fill: "url(#paint14_linear_35_222)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5088 316.684C53.7799 318.655 55.116 320.55 56.5533 322.406C57.0116 321.936 57.4185 321.465 57.7868 321.033C63.6119 314.216 63.6757 305.389 63.7643 300.405C64.3874 267.364 68.8639 260.839 62.2634 252.979C61.7802 252.395 60.012 250.296 57.1376 248.554C63.6494 256.388 59.2103 262.976 58.5872 295.916C58.4986 300.9 58.4225 309.727 52.6099 316.558C52.5725 316.595 52.5337 316.632 52.5088 316.684Z",
    fill: "url(#paint15_linear_35_222)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.865 268.408C34.0519 264.858 34.7179 262.247 36.0499 257.025C37.7918 250.193 39.9766 246.863 38.5573 245.544C37.6338 244.685 35.8145 245.265 35.4019 245.397C29.1573 247.389 27.2243 259.104 27.4929 266.436C27.6576 270.925 28.753 275.944 30.3979 276.166C30.6569 276.2 31.3021 276.167 31.7632 275.759C33.5992 274.137 33.7224 271.106 33.865 268.408Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5767 280.937C29.5767 281.653 30.1568 282.233 30.8727 282.233C31.5885 282.233 32.1687 281.653 32.1687 280.937C32.1687 280.221 31.5885 279.641 30.8727 279.641C30.1568 279.641 29.5767 280.221 29.5767 280.937Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.819 401.046C65.2949 401.046 34.8757 388.592 34.8757 373.23C34.8757 357.868 65.2949 345.414 102.819 345.414C140.343 345.414 170.762 357.868 170.762 373.23C170.762 388.592 140.343 401.046 102.819 401.046Z",
    fill: "url(#paint16_radial_35_222)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.392 131.829H384.245C420.384 131.829 449.954 102.259 449.954 66.1195C449.954 29.9797 420.384 0.409851 384.245 0.409851H291.392C255.252 0.409851 225.683 29.9797 225.683 66.1195C225.683 102.259 255.251 131.829 291.392 131.829Z",
    fill: "url(#paint17_linear_35_222)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_35_222",
    x1: 279.744,
    y1: 109.1,
    x2: 261.938,
    y2: 157.428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABF0A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEFA8E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_35_222",
    x1: 183.079,
    y1: 246.582,
    x2: 59.5107,
    y2: 342.617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0397,
    stopColor: "#06BED8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEFA8E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_35_222",
    x1: 120.034,
    y1: 36.5523,
    x2: 99.6853,
    y2: 33.5848,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0397,
    stopColor: "#06CFF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEFA8E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_35_222",
    x1: 125.224,
    y1: 88.2227,
    x2: 89.1123,
    y2: 47.4513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0397,
    stopColor: "#06CFF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEFA8E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_35_222",
    x1: 177.529,
    y1: 229.447,
    x2: 34.4315,
    y2: 86.3491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0397,
    stopColor: "#06CFF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEFA8E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_35_222",
    x1: 106.587,
    y1: 175.924,
    x2: 105.315,
    y2: 118.693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#030D14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B2F45"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_35_222",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(139.802 146.879) rotate(180) scale(23.7855)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1296,
    stopColor: "#3280FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_35_222",
    x1: 154.292,
    y1: 146.879,
    x2: 125.313,
    y2: 146.879,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#030D14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B2F45"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_35_222",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.8748 146.879) rotate(180) scale(23.7855 23.7855)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1296,
    stopColor: "#3280FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_35_222",
    x1: 89.3638,
    y1: 146.879,
    x2: 60.3855,
    y2: 146.879,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#030D14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B2F45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_35_222",
    x1: 124.505,
    y1: 11.9802,
    x2: 97.5749,
    y2: 8.05288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0397,
    stopColor: "#06CFF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEFA8E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_35_222",
    x1: 107.08,
    y1: 198.152,
    x2: 65.648,
    y2: 156.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0714,
    stopColor: "#0DA9AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEFA8E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_35_222",
    x1: 146.21,
    y1: 323.881,
    x2: 36.4372,
    y2: 195.695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0397,
    stopColor: "#06CFF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0408,
    stopColor: "#06CFF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1607,
    stopColor: "#37D9DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2745,
    stopColor: "#5DE0CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3793,
    stopColor: "#78E6BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4719,
    stopColor: "#88E9B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5423,
    stopColor: "#8EEAB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8004,
    stopColor: "#B9F39F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEFA8E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_35_222",
    x1: 152.025,
    y1: 259.975,
    x2: 86.012,
    y2: 182.888,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0397,
    stopColor: "#06CFF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEFA8E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_35_222",
    x1: 10.1859,
    y1: 304.74,
    x2: 92.3756,
    y2: 244.628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0397,
    stopColor: "#06CFF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0734,
    stopColor: "#0FD1ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4151,
    stopColor: "#67E2C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6937,
    stopColor: "#A7EFA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8955,
    stopColor: "#CFF795"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEFA8E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_35_222",
    x1: 82.6168,
    y1: 298.911,
    x2: 24.3687,
    y2: 268.556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0397,
    stopColor: "#06BED8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEFA8E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_35_222",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(102.819 373.23) rotate(180) scale(67.9429 27.815)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCD7D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_35_222",
    x1: 449.954,
    y1: 66.1192,
    x2: 225.683,
    y2: 66.1192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#06CFF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEFA8E"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_35_222"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 450,
    height: 401.538,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRobot);
export default __webpack_public_path__ + "static/media/Robot.53b38535d94ac89412fb75718494001c.svg";
export { ForwardRef as ReactComponent };